import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";
import { ReduxStateType } from "redux-store/types";

const newsSelector = (state: RootState) => state.news;

// residence information
const newsTabsSelector = createSelector(
  newsSelector,
  (state) => state.getNewsTabs
);

export const commentsSelector = createSelector(
  newsSelector,
  (state) => state.getComments
);

export const commentsStatusSelector = createSelector(
  commentsSelector,
  (state) => state.status
);

export const postCommentSelector = createSelector(
  newsSelector,
  (state) => state.postComment
);

export const postCommentStatusSelector = createSelector(
  postCommentSelector,
  (state) => state.status
);

export const newsTabsDataSelector = createSelector(newsTabsSelector, (state) =>
  state.data.map(({ id, name }) => ({
    name: name.toString(),
    value: id.toString(),
  }))
);

// news filter form
const newsFilterFormSelector = createSelector(
  newsSelector,
  (state) => state.newsFilterForm
);

export const newsFilterFormDataSelector = createSelector(
  newsFilterFormSelector,
  (state) => state.data
);

// news
const listNewsSelector = createSelector(newsSelector, (state) => state.getNews);

export const newsByTypeSelector = (type: string) =>
  createSelector(listNewsSelector, (state) =>
    state[type] ? state[type]?.data : []
  );

export const newsCategoryNameByTypeSelector = (type: string) =>
  createSelector(listNewsSelector, (state) =>
    state[type] ? state[type]?.categoryName : ""
  );

export const newsStatusByTypeSelector = (type: string) =>
  createSelector(listNewsSelector, (state) =>
    state[type] ? state[type]?.status : ReduxStateType.INIT
  );

export const formCommentSelector = createSelector(newsSelector, (state) => ({
  formComment: state.formComment,
}));

// news detail

const newsDetailSelector = createSelector(newsSelector, (state) => state.getNewsDetail);

export const newsDetailDataSelector = createSelector(
  newsDetailSelector,
  (state) => state.data
);

export const newsDetailStatusSelector = createSelector(
  newsDetailSelector,
  (state) => state.status
);

// like

const likeNewsSelector = createSelector(newsSelector, (state) => state.likeNews);

export const likeNewsStatusSelector = createSelector(
  likeNewsSelector,
  (state) => state.status
);

export const likeNewsDataSelector = createSelector(
  likeNewsSelector,
  (state) => state.data
);

